import AbstractScene from './AbstractScene.js';

import {Colors} from "../consts/Colors.js"
import {tags} from "../consts/Tags.js"

import RoundedButton from '../prefabs/RoundedButton.js';

export default class Menu extends AbstractScene {
    constructor() {
        super({
            key: "Menu"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        
        this._preload();

        this.questionGroup = this.add.group()
    }

    create(){
        // Background
        var back = this.add.sprite(this.width, 0, 'intro').setOrigin(1, 0)
        // back.setScale(0.45)

        var rect = this.add.sprite(0,0, 'rectIntro').setOrigin(0)
        
        // Ajout line
        var line = this.add.sprite(0, this.height, 'backLine').setOrigin(0, 1)

        // Ajout logo
        var logoABC = this.add.sprite(416, 148, "mqde")

        // Ajout titre
        var Y = 275
        var titreFond = this.add.rexTagText(73, Y-1, "Trésorerie nette,\nFonds de Roulement\net Besoin en Fonds de Roulement", {
            fontSize: "63px",
            fontFamily: "MassiliaBold",
            align: 'left',
            color: Colors.Text.White,
            // stroke: Colors.Text.Black,
            // strokeThickness: 2,
            backgroundColor: 'transparent',
            wrap: {
                mode: 'word',
                width: 700
            },
            tags: tags
        })
        titreFond.setOrigin(0)

        var Ytxt = 645
        var text = "Après avoir visionné la vidéo, découvrez le\n"   
                    +"jeu pédagogique sur la Trésorerie nette, le\n"  
                    +"Fonds de Roulement et le Besoin en Fonds de\n"
                    +"Roulement."
                    +"\n\nRestez bien jusqu'à la fin pour tester vos"
                    +"\nconnaissances !"
                    
        var textElmt = this.add.rexTagText(titreFond.x, Ytxt, text, {
            fontSize: "35px",
            fontFamily: "MassiliaRegular",
            align: 'left',
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            tags: tags
        })
        textElmt.setOrigin(0)

        // Ajout bouton
        var button = new RoundedButton(this, this.width/2, 965, 500, 100, "Démarrer la vidéo", Colors.Text.Purple, Colors.Elmt.Purple)
        button.setClickFunction(()=>{this.nextScene()})
    }
}